import { Helmet } from '@dr.pogodin/react-helmet';
import { config } from '@iheartjane/config';

export const JQUERY_SDK_URL =
  'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js';
export const STRONGHOLD_SDK_URL = 'https://api.strongholdpay.com/v2/js';

export interface CheckoutPaymentScriptsProps {
  hasCanpay: boolean;
  hasMoneris: boolean;
  hasSquare: boolean;
  hasStronghold: boolean;
}

export const CheckoutPaymentScripts = ({
  hasCanpay,
  hasMoneris,
  hasSquare,
  hasStronghold,
}: CheckoutPaymentScriptsProps) => (
  <Helmet>
    {hasStronghold && <script src={JQUERY_SDK_URL}></script>}
    {hasStronghold && <script src={STRONGHOLD_SDK_URL}></script>}
    {hasCanpay && <script async src={config.canPayV2RemotePaySDK}></script>}
    {hasSquare && <script async src={config.squareWebPaymentsSdkUrl}></script>}
    {hasMoneris && <script defer async src={config.monerisJsSdkUrl}></script>}
  </Helmet>
);
